define('ItemSegmentation.Item.Model', [
    'ProductList.Utils',
    'Profile.Model',
    'Item.Collection',
    'Item.Model',
    'Session',
    'ItemSegmentation.Utils',
    'underscore'
], function ItemSegmentationItemModel(
    ProductListUtils,
    ProfileModel,
    ItemCollection,
    ItemModel,
    Session,
    ItemSegmentationUtils,
    _
) {
    'use strict';

    _.extend(ItemModel.prototype, {
        parse: _.wrap(ItemModel.prototype.parse, function parse(fn) {
            var response = fn.apply(this, _.toArray(arguments).slice(1));
            var matrixChildItems = [];
            if (response.matrixchilditems_detail && response.matrixchilditems_detail.length > 0) {
                _.each(response.matrixchilditems_detail, function eachChild(item) {
                    if (ItemSegmentationUtils.isDomainVisible(
                        item.custitem_awa_domains,
                        ItemSegmentationUtils.getStorefrontDomains()
                    )) {
                        matrixChildItems.push(item);
                    }
                });
            }

            response.matrixchilditems_detail = matrixChildItems;

            return response;
        })
    });
});
